export default __webpack_public_path__ + "static/DMMono-Regular-a5229d025177e04a9f3137be8f9809fb.otf";